import * as React from 'react';
import { formatNumeral } from '@utils/helpers';

import type { FormatNumberPropsType } from './types';

const FormatNumber: React.FC<FormatNumberPropsType> = ( props: FormatNumberPropsType ) => {
    const locale = ( props.useLocale ? props.useLocale : 'de' ).split( '-' )[ 0 ];
    const formatted = formatNumeral( props.children, props.format ? props.format : '0,0.00', locale );

    const RenderElement = props.renderElement ? props.renderElement : 'span';
    const renderProps = props.renderProps ? props.renderProps : {};
    return (
        <RenderElement { ...renderProps }>
            { props.prefix }{ formatted }{ props.suffix }
        </RenderElement>
    );
};

export { FormatNumber };
